module.exports = __webpack_public_path__ + "img/info-white.dca2aeeb.svg";